import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "button", "feedback"];
  static values = {
    successButtonText: String,
    successFeedbackText: String,
    failureButtonText: String,
    failureFeedbackText: String,
  };

  async copy(event) {
    event.preventDefault();

    const text = this.sourceTarget.dataset.copyValue || this.sourceTarget.textContent.trim();

    if (!text) {
      return;
    }

    const originalText = this.originalButtonText();

    try {
      await this.writeToClipboard(text);
      this.updateState(
        this.hasSuccessButtonTextValue ? this.successButtonTextValue : originalText,
        this.hasSuccessFeedbackTextValue ? this.successFeedbackTextValue : "",
      );
    } catch {
      this.updateState(
        this.hasFailureButtonTextValue ? this.failureButtonTextValue : originalText,
        this.hasFailureFeedbackTextValue ? this.failureFeedbackTextValue : "",
      );
    }
  }

  async writeToClipboard(text) {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        return;
      } catch {
        this.copyWithSelection(text);
        return;
      }
    }

    this.copyWithSelection(text);
  }

  copyWithSelection(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed";
    textArea.style.inset = "0 auto auto -9999px";
    document.body.appendChild(textArea);
    textArea.select();

    const copied = document.execCommand("copy");
    textArea.remove();

    if (!copied) {
      throw new Error("Copy command failed");
    }
  }

  updateState(buttonText, feedbackText) {
    if (this.hasButtonTarget) {
      const originalText = this.originalButtonText();
      this.buttonTarget.textContent = buttonText;

      window.clearTimeout(this.resetTimer);
      this.resetTimer = window.setTimeout(() => {
        this.buttonTarget.textContent = originalText;
      }, 2000);
    }

    if (this.hasFeedbackTarget) {
      this.feedbackTarget.textContent = feedbackText;
    }
  }

  disconnect() {
    window.clearTimeout(this.resetTimer);
  }

  originalButtonText() {
    if (!this.hasButtonTarget) {
      return "";
    }

    const originalText = this.buttonTarget.dataset.originalText || this.buttonTarget.textContent.trim();
    this.buttonTarget.dataset.originalText = originalText;
    return originalText;
  }
}
